var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',[_c('div',{ref:"tableau"}),_c('div',{attrs:{"id":"some"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }